import { Component, computed, effect, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';

export interface PickerOption {
  id: string;
  name: string;
}

const PAGE_SIZE = 7;

@Component({
  selector: 'lib-option-picker',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatProgressSpinnerModule, MatButtonModule],
  templateUrl: './option-picker.component.html',
  styleUrl: './option-picker.component.scss'
})
export class OptionPickerComponent {
  title = input.required<string>();
  subtitle = input<string>('');
  searchPlaceholder = input<string>('Search');
  items = input<PickerOption[]>([]);
  loading = input<boolean>(false);
  errorMessage = input<string | null>(null);
  emptyNoun = input<string>('results');
  icon = input<string>('business');

  selected = output<string>();

  searchQuery = signal('');
  currentPage = signal(1);

  filteredItems = computed(() => {
    const query = this.searchQuery().trim().toLowerCase();
    const list = this.items();
    if (!query) {
      return list;
    }
    return list.filter(item =>
      item.name.toLowerCase().includes(query) || item.id.toLowerCase().includes(query)
    );
  });

  totalPages = computed(() => Math.ceil(this.filteredItems().length / PAGE_SIZE) || 1);

  pageItems = computed(() => {
    const page = this.currentPage();
    const start = (page - 1) * PAGE_SIZE;
    return this.filteredItems().slice(start, start + PAGE_SIZE);
  });

  constructor() {
    effect(() => {
      const total = this.totalPages();
      const current = this.currentPage();
      if (current > total && total > 0) {
        this.currentPage.set(total);
      }
    });
  }

  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery.set(input?.value ?? '');
    this.currentPage.set(1);
  }

  goToPage(page: number): void {
    const total = this.totalPages();
    if (page >= 1 && page <= total) {
      this.currentPage.set(page);
    }
  }
}
